import { createContext, useContext } from "react";

export type AnnouncementContextType = {
  announce: (message: string, callback?: (() => void)|null,time?:number) => void;
};

export const AnnouncementContext = createContext<AnnouncementContextType | null>(null);

export const useAnnouncement = (): AnnouncementContextType => {
  const context = useContext(AnnouncementContext);
  if (!context) {
    throw new Error("useAnnouncement must be used inside AnnouncementProvider");
  }
  return context;
};
